// extracted by mini-css-extract-plugin
module.exports = {"dotBase":"Dot_dotBase__1ZQKU","dotLarge":"Dot_dotLarge__1tzkn"};